// Data User Admin
export const adminUsers = [
    {
        id: 1,
        username: 'admin',
        password: 'admin123',
        name: 'Administrator',
        role: 'superadmin',
        email: 'admin@magelangkota.go.id'
    },
];

// Data Profil
export const profilData = {
    visiMisi: {
        visi: "Terwujudnya Pengelolaan Keuangan dan Aset Daerah yang Profesional, Akuntabel, dan Transparan untuk Mendukung Kesejahteraan Masyarakat Kota Magelang",
        misi: [
            "Meningkatkan kualitas pengelolaan keuangan daerah yang efektif, efisien, dan akuntabel",
            "Mengoptimalkan pengelolaan aset daerah untuk meningkatkan Pendapatan Asli Daerah (PAD)",
            "Mewujudkan transparansi dan akuntabilitas dalam pengelolaan keuangan dan aset daerah",
            "Meningkatkan kualitas pelayanan publik melalui inovasi dan digitalisasi layanan",
            "Mengembangkan kompetensi SDM yang profesional dan berintegritas"
        ]
    },
    tupoksi: {
        tugas: [
            "Melaksanakan urusan pemerintahan daerah di bidang pengelolaan keuangan dan aset daerah",
            "Merumuskan kebijakan teknis di bidang pengelolaan keuangan dan aset daerah",
            "Mengkoordinasikan pelaksanaan tugas di bidang pengelolaan keuangan dan aset daerah",
            "Membina dan melaksanakan tugas di bidang pengelolaan keuangan dan aset daerah"
        ],
        fungsi: [
            "Perumusan kebijakan teknis sesuai dengan lingkup tugasnya",
            "Penyelenggaraan urusan pemerintahan dan pelayanan umum",
            "Pembinaan dan pelaksanaan tugas sesuai dengan lingkup tugasnya",
            "Pelaksanaan tugas lain yang diberikan oleh Walikota"
        ]
    },
    strukturOrganisasi: [
        { id: 1, jabatan: "Kepala BPKAD", nama: "Nama Kepala BPKAD", nip: "19650101 199003 1 001", level: 1 },
        { id: 2, jabatan: "Sekretaris", nama: "Nama Sekretaris", nip: "19680101 199103 1 002", level: 2 },
        { id: 3, jabatan: "Kabid Anggaran", nama: "Nama Kabid", nip: "19700101 199203 1 003", level: 2 },
        { id: 4, jabatan: "Kabid Perbendaharaan", nama: "Nama Kabid", nip: "19720101 199303 1 004", level: 2 },
        { id: 5, jabatan: "Kabid Akuntansi", nama: "Nama Kabid", nip: "19740101 199403 1 005", level: 2 },
        { id: 6, jabatan: "Kabid Aset", nama: "Nama Kabid", nip: "19760101 199503 1 006", level: 2 }
    ],
    standarPelayanan: [
        { id: 1, layanan: "Pelayanan Retribusi IPT", persyaratan: "KTP, Formulir, Dokumen Pendukung", waktu: "7 Hari Kerja", biaya: "Sesuai Perda" },
        { id: 2, layanan: "Pelayanan Retribusi IPR", persyaratan: "KTP, Formulir, Surat Izin Usaha", waktu: "5 Hari Kerja", biaya: "Sesuai Perda" },
        { id: 3, layanan: "Perizinan Aset", persyaratan: "Proposal, Dokumen Legalitas", waktu: "14 Hari Kerja", biaya: "Gratis" }
    ],
    kontak: {
        alamat: "Jl. Jend. Sudirman No. 10, Magelang, Jawa Tengah 56111",
        telepon: "(0293) 123456",
        email: "bpkad@magelangkota.go.id",
        instagram: "@bpkadmagelang",
        jamOperasional: "Senin-Kamis: 07.30-16.00 | Jumat: 07.30-16.30"
    }
};

// Data Artikel/Berita
export const artikelData = [
    {
        id: 1,
        judul: "BPKAD Luncurkan Sistem Pembayaran Retribusi Online",
        kategori: "berita",
        status: "published",
        tanggal: "2024-01-15",
        author: "Tim BPKAD",
        image: "https://placehold.co/800x400/0D9488/FFFFFF?text=Berita+1",
        summary: "Inovasi terbaru dalam pelayanan pembayaran retribusi daerah",
        content: "BPKAD Kota Magelang meluncurkan sistem pembayaran retribusi online untuk memudahkan masyarakat...",
        tags: ["Inovasi", "Retribusi", "Digital"]
    },
    {
        id: 2,
        judul: "Sosialisasi e-Retribusi kepada Pelaku Usaha",
        kategori: "kegiatan",
        status: "published",
        tanggal: "2024-01-20",
        author: "Tim BPKAD",
        image: "https://placehold.co/800x400/1E3A8A/FFFFFF?text=Kegiatan+1",
        summary: "Sosialisasi sistem pembayaran retribusi elektronik kepada pelaku usaha",
        content: "Kegiatan sosialisasi dihadiri oleh 100 pelaku usaha dari berbagai sektor...",
        tags: ["Sosialisasi", "e-Retribusi"]
    },
    {
        id: 3,
        judul: "Optimalisasi Aset Daerah Tahun 2024",
        kategori: "artikel",
        status: "draft",
        tanggal: "2024-02-01",
        author: "Bidang Aset",
        image: "https://placehold.co/800x400/0F172A/FFFFFF?text=Artikel+1",
        summary: "Strategi optimalisasi aset daerah untuk peningkatan PAD",
        content: "Pemerintah Kota Magelang terus berupaya mengoptimalkan aset daerah...",
        tags: ["Aset", "PAD", "Optimalisasi"]
    }
];

// Data Layanan
export const layananData = [
    {
        id: 1,
        nama: "Retribusi IPT",
        kategori: "retribusi",
        status: "active",
        deskripsi: "Layanan pembayaran retribusi Izin Pemakaian Tanah",
        icon: "📄",
        link: "/layanan/retribusi-ipt",
        persyaratan: ["KTP", "Formulir", "Dokumen Pendukung"],
        prosedur: ["Ajukan permohonan", "Verifikasi", "Pembayaran", "Terbit Izin"],
        tarif: "Sesuai Perda"
    },
    {
        id: 2,
        nama: "Retribusi IPR",
        kategori: "retribusi",
        status: "active",
        deskripsi: "Layanan pembayaran retribusi Izin Pemakaian Ruangan",
        icon: "🏢",
        link: "/layanan/retribusi-ipr",
        persyaratan: ["KTP", "Formulir", "Surat Izin Usaha"],
        prosedur: ["Ajukan permohonan", "Verifikasi", "Pembayaran", "Terbit Izin"],
        tarif: "Sesuai Perda"
    },
    {
        id: 3,
        nama: "Sewa Gedung",
        kategori: "sewa",
        status: "active",
        deskripsi: "Layanan sewa gedung dan bangunan milik Pemkot",
        icon: "🏠",
        link: "/layanan/sewa-gedung",
        persyaratan: ["KTP", "Proposal", "Surat Pernyataan"],
        prosedur: ["Cek ketersediaan", "Booking", "Pembayaran", "Serah Terima"],
        tarif: "Bervariasi"
    }
];